import { useEffect, useState } from 'react'
import { apiURL } from '../utilities/URLs'
import { affiliateData, company } from '../data/AffiliateData'
import { useTheme } from '../ThemeContext'
import { refreshAccessToken } from '../utilities/extensions'
import { useNavigate } from 'react-router-dom'

export default function SubAffiliateList() {
  const navigate = useNavigate()
  const { isDarkMode } = useTheme()

  const [loadingSubAffiliates, setLoadingSubAffiliates] = useState(true)
  const [subAffiliateData, setSubAffiliateData] = useState([])
  const [searchQuery, setSearchQuery] = useState('')

  useEffect(() => {
    const getSubAffiliateInfo = async () => {
      const subAffiliateInfoResponse = await fetch(`${apiURL}/api/getSubAffiliateData?accountId=${affiliateData.account.accountId}`, {
        headers: {
          'Authorization': affiliateData.accessToken
        }
      })
      const subAffiliateInfoData = await subAffiliateInfoResponse.json()
      if(subAffiliateInfoData.response.error) {
        if(subAffiliateInfoData.response.error === 'Failed To Authenticate Token.') {
          const refreshedToken = await refreshAccessToken()
          refreshedToken && refreshedToken.length > 0 ? await getSubAffiliateInfo() : navigate('/affiliate', { state: { expired: true }})
        } else
          console.error(subAffiliateInfoData.response.error)
      } else {
        setSubAffiliateData(subAffiliateInfoData.response.allSubAffiliateData)
        setLoadingSubAffiliates(false)
      }
    }

    getSubAffiliateInfo()
  }, [])

  useEffect(() => {
    document.title = `${company.companyName} | Sub Affiliates List`
  }, [])

  const filteredSubAffiliates = subAffiliateData.filter(subAffiliate =>
    subAffiliate.subAffiliateName.toLowerCase().startsWith(searchQuery.toLowerCase())
  )

  return (
    <div className='flex flex-col justify-center items-center h-[90vh] text-center font-mont'>
      <div className={`flex flex-col h-3/4 w-3/4 lg:w-1/3 shadow-lg rounded-lg overflow-hidden ${isDarkMode ? 'bg-gray-800' : 'bg-white'}`}>
        <div className={`text-2xl font-semibold text-gray-800 py-4 bg-gray-50 border-b border-gray-200 text-center ${isDarkMode && 'text-white bg-gray-800'}`}>
          Sub Affiliates Table
        </div>
        <div className='p-4'>
          <input 
            type='text'
            placeholder='Search affiliates...'
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className={`w-full p-2 mb-4 text-gray-700 border rounded-lg focus:outline-none focus:shadow-outline ${isDarkMode && 'bg-gray-800 text-white'}`}
          />
        </div>
        {loadingSubAffiliates && (
          <div className='flex flex-row items-center justify-center gap-2 mb-5 col-span-2 font-mont'>
            <div className='loader ease-linear rounded-full border-[6px] border-t-[6px] h-8 w-8'></div>
            <p className={`text-md text-center ${isDarkMode && 'text-white'}`}>Fetching Sub Affiliate Data...</p>
          </div>
        )}
        <div className='overflow-y-auto'>
          <table className='text-center w-full'>
            <thead>
              <tr>
                <th className={`w-[33.33%] p-4 border-b-2 border-gray-200 bg-gray-100 text-center text-[10px] lg:text-xs font-semibold text-gray-600 uppercase tracking-wider ${isDarkMode && 'bg-gray-800 text-white'}`}>Affiliate Name</th>
                <th className={`w-[33.33%] p-4 border-b-2 border-gray-200 bg-gray-100 text-center text-[10px] lg:text-xs font-semibold text-gray-600 uppercase tracking-wider ${isDarkMode && 'bg-gray-800 text-white'}`}>Total Amount</th>
                <th className={`w-[33.33%] p-4 border-b-2 border-gray-200 bg-gray-100 text-center text-[10px] lg:text-xs font-semibold text-gray-600 uppercase tracking-wider ${isDarkMode && 'bg-gray-800 text-white'}`}>Total Leads</th>
              </tr>
            </thead>
            <tbody>
              {filteredSubAffiliates.length > 0 ? (
                filteredSubAffiliates.map((subAffiliate, index) => (
                  <tr key={index}>
                    <td className={`w-[33.33%] p-4 border-b border-gray-200 max-sm:text-xs ${isDarkMode && 'text-white'}`}>{subAffiliate.subAffiliateName}</td>
                    <td className={`w-[33.33%] p-4 border-b border-gray-200 max-sm:text-xs ${isDarkMode && 'text-white'}`}>${subAffiliate.subAffiliateTotalAmount.toLocaleString('en-US', { style: 'decimal', minimumFractionDigits: subAffiliate.subAffiliateTotalAmount % 1 !== 0 ? 2 : 0})}</td>
                    <td className={`w-[33.33%] p-4 border-b border-gray-200 max-sm:text-xs ${isDarkMode && 'text-white'}`}>{subAffiliate.subAffiliateLeads.length}</td>
                  </tr>
                ))
              ) : (
                !loadingSubAffiliates && (
                  <tr>
                    <td colSpan='3' className={`p-2 text-gray-700 ${isDarkMode && 'text-white'}`}>No Sub Affiliates Found.</td>
                  </tr>
                )
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}